import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=b7fbb55e&scoped=true&"
import script from "./gate.vue?vue&type=script&lang=js&"
export * from "./gate.vue?vue&type=script&lang=js&"
import style0 from "./gate.vue?vue&type=style&index=0&id=b7fbb55e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fbb55e",
  null
  
)

export default component.exports